import { render, staticRenderFns } from "./TableAssigmentsView.vue?vue&type=template&id=231ba49f&"
import script from "./TableAssigmentsView.vue?vue&type=script&lang=ts&"
export * from "./TableAssigmentsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports